import React from 'react'
import { TableCustom } from '../../../components/table/Table';
import {  CouponHistory } from '../../../models/dto/entry';
import { formatDateTime, formatNumber } from '../../../utils/function-utils';
import { useInitialCofig } from '../../../hooks/initialConfig-hook';
//AVCDAAV.002  20/03/2025  Add code for Adding coupon history page
type Props = {
    couponHistory?: CouponHistory[];
}
const History = (props: Props) => {
    const { initialConfig } = useInitialCofig();
    const [headerTable] = React.useState<string[]>(["Date", "Coupon", "Point"]);


    const renderTableRows = () => {
        return props.couponHistory?.sort((a, b) => {
            const latestDate = new Date(`${b.createDate} ${b.createTime}`).getTime();
            const prevDate = new Date(`${a.createDate} ${a.createTime}`).getTime();
            return latestDate - prevDate
        }).map((item, i) => {
            return (
                <tr key={item.couponCode} 
                    style={initialConfig.styles.title2_style}
                >
                    <td>{formatDateTime(item.createDate)}</td>
                    <td style={{ textAlign: 'left', overflow: "hidden", whiteSpace: "nowrap", maxWidth: "200px", textOverflow: "ellipsis" }}>{item.couponDesc}</td>
                    <td style={{ textAlign: "right" }}>{item.pointforRedeem === 0 ? "ฟรี" : formatNumber("en-US", item.pointforRedeem)}</td>
                </tr>
            )
        });
    };

    if(!props.couponHistory || props.couponHistory.length === 0) return (
        <div className='box-loading'>
            <div className={`loading-container ${'with-bottombar'} smallest`}>
                ไม่มีคูปอง
            </div>
        </div>
    )

    return (
        <React.Fragment>
            <div className='history'>
            <TableCustom  renderTableRows={renderTableRows} styleConfig={initialConfig.styles} theadCentered 
                tbodyCentered tbodyStyle={{fontSize: "14px", fontWeight: "bold", backgroundColor: "white"}} headers={headerTable}
            />
            </div>
        </React.Fragment>
    )
}

export default History
//C-AVCDAAV.002  20/03/2025  Add code for Adding coupon history page